export interface TagColorOption {
  key: string;
  value: string;
}

export const TAG_COLOR_OPTIONS: readonly TagColorOption[] = [
  { key: 'navy', value: '#1e3a8a' },
  { key: 'blue', value: '#2563eb' },
  { key: 'sky', value: '#0284c7' },
  { key: 'teal', value: '#0f766e' },
  { key: 'green', value: '#15803d' },
  { key: 'lime', value: '#65a30d' },
  { key: 'amber', value: '#b45309' },
  { key: 'orange', value: '#c2410c' },
  { key: 'red', value: '#b91c1c' },
  { key: 'pink', value: '#be185d' },
  { key: 'purple', value: '#7e22ce' },
  { key: 'slate', value: '#475569' },
];

export const DEFAULT_TAG_COLOR = TAG_COLOR_OPTIONS[0].value;
